import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labsComponents from 'vuetify/labs/components'
import { logError, logNetworkError } from './services/logService';



const myCustomLightTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    textColor : '#000000',
    secondaryTextColor : '#515151',

    secondaryBackground : "#f0f0f0",
    navColor : "#F8F8F8",
    cardHoverColor : "#FFFF",
    // borderHoverColor : "",
        surface: '#FFFFFF',
    primary: '#536DFE',
    'primary-darken-1': '#3700B3',
    secondary: '#F3F2F3',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    navbar: "#0D143C",
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
    'login-background': '#0D143C',
    'poweredby-mentoColor': '#FFFFFF',
    'poweredby-mindColor': '#536DFE',
    'content-background': '#FCFCFC',
    'domain-button-color': '#494F6C',
  }
}

const vuetify = createVuetify({
  components : {
  ...components,
  ...labsComponents
  },
  directives,

  theme: {
    options: {
      customProperties: true,
    },
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    }
  }
})

axios.interceptors.response.use(
  response => response,
  error => {
    logNetworkError(error);
    return Promise.reject(error);
  }
);

const app = createApp(App);

app.config.errorHandler = (err, instance, info) => {
  logError(err,info);
}

app.use(store).use(router).use(vuetify).mount('#app')
